import { loadablePage } from 'src/utils/loadable';

export default loadablePage(
  () =>
    import(
      /* webpackChunkName: "NotMyCompanyErrorModal." */ /* webpackPrefetch: true */
      './NotMyCompanyErrorModal.component'
    ),
);
